import {
  faBarsStaggered,
  faGrid,
  faObjectsColumn,
  faRectangleVerticalHistory,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { RadioCardGroup } from '@/components/ui/form/radio-card-group';
import { Icon } from '@/components/ui/icon';
import { MutedText } from '@/components/ui/typography';
import {
  getCollectionVariants,
  type LayoutRenderer,
  type LayoutVariantEntry,
} from '@/lib/blocks/collection/variant-registry';

const VARIANT_ICONS: Record<LayoutRenderer, typeof faGrid> = {
  grid: faGrid,
  alternating: faObjectsColumn,
  carousel: faRectangleVerticalHistory,
  accordion: faBarsStaggered,
};

export function LayoutTab({
  variant,
  variants = getCollectionVariants(),
  onVariantChange,
}: {
  variant: string;
  variants?: LayoutVariantEntry[];
  onVariantChange: (key: string) => void;
}) {
  if (variants.length <= 1) {
    return <MutedText>No display options available.</MutedText>;
  }

  const options = variants.map((v) => ({
    value: v.key,
    title: v.label,
    icon: <Icon icon={VARIANT_ICONS[v.renderer] ?? faGrid} className="size-5" />,
  }));

  return (
    <RadioCardGroup
      aria-label="Collection layout"
      className="w-full min-w-0"
      value={variant}
      onValueChange={onVariantChange}
      options={options}
      gridColumns="grid-cols-2 md:grid-cols-4"
      gridGap="gap-2 md:gap-3"
      hideRadio
    />
  );
}
